module.exports = __webpack_public_path__ + "static/img/logo_cbs.2539679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_cbs.jpg
// module id = 4C6Z
// module chunks = 0